// extracted by mini-css-extract-plugin
export default {"BlockScreen":"BlockScreen_BlockScreen__zOzM8"};